import { SignupForm } from "./SignupForm";

/**
 * SignupPage Component
 * Page-level component that composes views
 */
export const SignupPage = () => {
  return <SignupForm />;
};
